// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c44a7f131ea78fc8","3277":"5d0f469b70340381","5074":"1c87faa4be1f1032"}[chunkId] + ".css";
};